<template>
  <div class="history-search-bar">
    <el-form :model="searchForm" label-position="top">
      <el-row :gutter="20">
        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('MemberRegistrationReview.applicantStatus')">
            <el-select v-model="searchForm.applicantStatus" filterable
                       :placeholder="$t('MemberRegistrationReview.applicantStatusPlaceholder')" :clearable="true"
                       class="custom-tree-select-width"
                       label-position="top">
              <el-option :label="$t('MemberRegistrationReview.statusPending')" value="pending"/>
              <el-option :label="$t('MemberRegistrationReview.statusApproved')" value="approved"/>
              <el-option :label="$t('MemberRegistrationReview.statusRejected')" value="rejected"/>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('MemberRegistrationReview.applyTime')">
            <el-date-picker v-model="searchForm.applyTime" type="datetimerange" :clearable="true"
                            :start-placeholder="$t('MemberRegistrationReview.startDatePlaceholder')"
                            :end-placeholder="$t('MemberRegistrationReview.endDatePlaceholder')"/>
          </el-form-item>
        </el-col>

        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('MemberRegistrationReview.contactName')">
            <el-input v-model="searchForm.contactName" filterable
                      :placeholder="$t('MemberRegistrationReview.contactNamePlaceholder')" :clearable="true"
                      class="custom-tree-select-width"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" :sm="12" :md="7" :lg="7">
          <el-form-item :label="$t('MemberRegistrationReview.storeName')">
            <el-input v-model="searchForm.storeName" filterable
                      :placeholder="$t('MemberRegistrationReview.storeNamePlaceholder')" :clearable="true"
                      class="custom-tree-select-width"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :sm="12" :md="7" :lg="4">
          <el-form-item label="&nbsp;">
            <el-button class="button-background-color" @click="search">
              {{ $t('MemberRegistrationReview.search') }}
            </el-button>
            <el-button @click="reset" class="custom-reset-button">
              {{ $t('MemberRegistrationReview.reset') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import dialogMixin from "@/mixins/dialogMixin";

export default {
  data() {
    return {
      searchForm: {
        applicantStatus: '',
        applyTime: '',
        contactName: '',
        storeName: '',
      },
    };
  },
  mixins: [dialogMixin],

  methods: {
    search() {
      let searchCondition = {};

      if (this.searchForm.applicantStatus) {
        const statusMap = {
          'pending': 0,
          'approved': 1,
          'rejected': 2
        };
        searchCondition["status-eq"] = statusMap[this.searchForm.applicantStatus];
      }

      if (this.searchForm.applyTime && this.searchForm.applyTime.length === 2) {
        const [start, end] = this.searchForm.applyTime;
        searchCondition["created_at-begin"] = this.formatDate(null, null, start);
        searchCondition["created_at-end"] = this.formatDate(null, null, end);
      }

      if (this.searchForm.contactName) {
        searchCondition["contactName-like"] = this.searchForm.contactName;
      }

      if (this.searchForm.storeName) {
        searchCondition["storeName-like"] = this.searchForm.storeName;
      }

      this.$emit('search', searchCondition);
    },
    reset() {
      this.searchForm = {
        applicantStatus: '',
        applyTime: '',
        contactName: '',
        storeName: '',
      };
      this.search();
    }
  },
};
</script>
<style scoped>
</style>